import { useMutation } from 'react-query';

import { Pet } from '@/features/availability/types';
import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { showNotification } from '@/utils/notificationUtils';

export type requestDTO = {
  data: {
    petId: number;
    allowNotifications: boolean;
  };
};

export const updatePetSettings = ({ data }: requestDTO): Promise<Pet> => {
  return axios.post(`parent/pet-settings/update`, data);
};

type UsePetOptions = {
  config?: MutationConfig<typeof updatePetSettings>;
};

export const useUpdatePet = ({ config }: UsePetOptions = {}) => {
  return useMutation({
    onSuccess: () => {
      showNotification({
        type: 'success',
        title: 'Pet settings updated successfully',
      });
    },
    ...config,
    mutationFn: updatePetSettings,
  });
};
